import { useEffect } from "react";

/**
 * Zatrzymuje przewijanie strony, dopóki otwarte jest okno modalne.
 *
 * Bez tego kółko myszy nad oknem przewijało listę pod spodem: okno stało
 * w miejscu, a tło jechało — i po zamknięciu człowiek był w zupełnie innym
 * miejscu listy, niż ją zostawił.
 *
 * Liczymy otwarte okna, a nie ustawiamy flagi: podgląd pliku bywa otwierany
 * z wnętrza innego okna i zamknięcie tego wierzchniego odblokowywałoby stronę
 * pod wciąż otwartym spodnim.
 */
let otwarte = 0;

export function useScrollLock(active = true): void {
  useEffect(() => {
    if (!active) return;

    otwarte += 1;
    document.body.classList.add("is-modal-open");

    return () => {
      otwarte -= 1;
      if (otwarte <= 0) {
        otwarte = 0;
        document.body.classList.remove("is-modal-open");
      }
    };
  }, [active]);
}
